// src/data/selectors/Patient/patient.selector.js
export const getPatientList = (store) => store.patient.data;

export const getPaginationInfo = (store) => {
  const { data, ...rest } = store.patient;
  return rest; // { current_page, page_size, has_more, total_page, total_count }
};
